<script setup lang="ts">
    import { Check } from 'lucide-vue-next';
    import { OnboardingStep } from '@/types';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';

    const props = withDefaults(
        defineProps<{
            onboardingStep: OnboardingStep;
            type?: 'light' | 'dark';
            class?: HTMLAttributes['class'];
        }>(),
        {
            type: 'dark',
        },
    );
</script>

<template>
    <div :class="cn('flex flex-1 flex-col items-center gap-2 px-1', props.class)">
        <div
            class="flex size-7 items-center justify-center rounded-full border-2"
            :class="{
                'bg-foreground': onboardingStep.is_completed && type === 'dark',
                'bg-white': onboardingStep.is_completed && type === 'light',
                'border-foreground text-white': type === 'dark',
                'text-foreground border-white': type === 'light',
            }"
        >
            <Check
                v-if="onboardingStep.is_completed"
                class="size-4"
            />
        </div>
        <span
            class="shrink-0 text-xs whitespace-nowrap"
            :class="{
                'text-foreground': type === 'dark',
                'text-white': type === 'light',
            }"
            >{{ onboardingStep.title }}</span
        >
    </div>
</template>
